export const WHATSAPP_NUMBER = "5511982864455";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WA_TATTOO = waLink("Olá, Diggy Shop! Quero fazer uma tattoo. Podem me passar um orçamento?");
export const WA_PIERCING = waLink("Olá, Diggy Shop! Quero colocar um piercing. Podem me ajudar?");

// Quando o vídeo institucional estiver pronto, colar a URL do MP4 aqui (formato 16:9)
export const VIDEO_URL = "/videos/hero-video.mp4";

export const LOGO_URL = "/logo.png";

export const INSTAGRAM_URL = "https://www.instagram.com/diggyshop__/";

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1513078094721-e7b6e0394a6a?auto=format&fit=crop&w=1920&q=80",
  videoPoster: "/photos/t2123.jpg",
  portfolio: [
    {
      src: "/photos/t2121.jpg",
      title: "Anubis & Hórus",
      tag: "BLACKWORK",
      span: "tall",
    },
    {
      src: "/photos/t2120.jpg",
      title: "Asas & Olhos",
      tag: "BLACKWORK",
      span: "wide",
    },
    {
      src: "/photos/t2123.jpg",
      title: "Náutica & Serpente",
      tag: "BLACKWORK",
      span: "wide",
    },
    {
      src: "/photos/t2122.jpg",
      title: "Dragão Floral",
      tag: "BLACKWORK",
      span: "half",
    },
    {
      src: "/photos/t2130.jpg",
      title: "Paisagem Aquarela",
      tag: "COLORIDA",
      span: "half",
    },
    {
      src: "/photos/g-tattoo-rosa-pescoco.jpg",
      title: "Rosa Delicada",
      tag: "BLACKWORK",
      span: "half",
    },
    {
      src: "/photos/g-tattoo-floral-borboletas.jpg",
      title: "Floral & Borboletas",
      tag: "BLACKWORK",
      span: "half",
    },
    {
      src: "/photos/g-tattoo-simbolo.jpg",
      title: "Símbolo Autoral",
      tag: "BLACKWORK",
      span: "half",
    },
  ],
  piercing: [
    {
      src: "/photos/p4.jpg",
      title: "A Loja por Dentro",
      tag: "A LOJA",
    },
    {
      src: "/photos/t2124.jpg",
      title: "Orelha Curada",
      tag: "PIERCING",
    },
    {
      src: "/photos/p5.jpg",
      title: "Anéis & Acessórios",
      tag: "JOIAS",
    },
    {
      src: "/photos/t2126.jpg",
      title: "Septo & Labret",
      tag: "PIERCING",
    },
    {
      src: "/photos/t2127.jpg",
      title: "Umbigo Clássico",
      tag: "PIERCING",
    },
    {
      src: "/photos/p3.jpg",
      title: "Joias em Aço & Titânio",
      tag: "JOIAS",
    },
    {
      src: "/photos/t2125.jpg",
      title: "Industrial & Alargador",
      tag: "PIERCING",
    },
    {
      src: "/photos/t2129.jpg",
      title: "Umbigo Azul",
      tag: "PIERCING",
    },
    {
      src: "/photos/g-piercing-nariz-ponto-luz.jpg",
      title: "Nariz Ponto de Luz",
      tag: "PIERCING",
    },
    {
      src: "/photos/g-piercing-septo.jpg",
      title: "Septo Ferradura",
      tag: "PIERCING",
    },
    {
      src: "/photos/g-piercing-orelha-composicao.jpg",
      title: "Composição de Orelha",
      tag: "PIERCING",
    },
  ],
};
